// extracted by mini-css-extract-plugin
export default {"iconContainer":"index_iconContainer__tcmV1","iconSVG":"index_iconSVG__iH9Tn"};